export const SUPPORTED_LANGUAGES = {
  ENGLISH: 'en',
  FRENCH: 'fr',
};
